// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__38C5u","errorLogs":"EditorFooter_errorLogs__2avfC"};